/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TotalSalesSummary } from './TotalSalesSummary';
import {
    TotalSalesSummaryFromJSON,
    TotalSalesSummaryFromJSONTyped,
    TotalSalesSummaryToJSON,
    TotalSalesSummaryToJSONTyped,
} from './TotalSalesSummary';
import type { TotalSales } from './TotalSales';
import {
    TotalSalesFromJSON,
    TotalSalesFromJSONTyped,
    TotalSalesToJSON,
    TotalSalesToJSONTyped,
} from './TotalSales';

/**
 * 
 * @export
 * @interface TotalSalesReport
 */
export interface TotalSalesReport {
    /**
     * 
     * @type {Array<TotalSales>}
     * @memberof TotalSalesReport
     */
    years: Array<TotalSales>;
    /**
     * 
     * @type {TotalSalesSummary}
     * @memberof TotalSalesReport
     */
    total: TotalSalesSummary;
}

/**
 * Check if a given object implements the TotalSalesReport interface.
 */
export function instanceOfTotalSalesReport(value: object): value is TotalSalesReport {
    if (!('years' in value) || value['years'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function TotalSalesReportFromJSON(json: any): TotalSalesReport {
    return TotalSalesReportFromJSONTyped(json, false);
}

export function TotalSalesReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): TotalSalesReport {
    if (json == null) {
        return json;
    }
    return {
        
        'years': ((json['years'] as Array<any>).map(TotalSalesFromJSON)),
        'total': TotalSalesSummaryFromJSON(json['total']),
    };
}

export function TotalSalesReportToJSON(json: any): TotalSalesReport {
    return TotalSalesReportToJSONTyped(json, false);
}

export function TotalSalesReportToJSONTyped(value?: TotalSalesReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'years': ((value['years'] as Array<any>).map(TotalSalesToJSON)),
        'total': TotalSalesSummaryToJSON(value['total']),
    };
}

